// Module
var code = `<div name="MarginOEControl" class="MarginOEControl" style="{{>visibility}};">
    <div class="margin-footer{{#if .attached}} attached{{/if}}">
        <div class="refreshBtn" on-click="refreshBtnClicked">
            <svg viewBox="0 0 16 16" as-tooltip="refreshBtnTooltip">
                <circle class="refreshBackCircle" cx="8" cy="8" r="7.5" />
                <circle class="refreshSector" style="stroke-dashoffset: {{progressOffset}};" cx="8" cy="8" r="7.5" />
            </svg>
        </div>
    </div>
</div>`;
// Exports
export default code;